"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=solana-admin-service-config.js.map